import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './resources';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en-US',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
  });

const updateDocumentLanguage = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = 'en-US';
};
i18n.on('languageChanged', updateDocumentLanguage);
updateDocumentLanguage();

export default i18n;
